import { AppThunk } from 'store/types';
import {
  setSendToSpruceErrorAction,
  setSendToSpruceFetchStatusAction,
  setVendorPayoffDataAction,
  setVendorPayoffErrorAction,
  setVendorPayoffFetchStatusAction,
  setUpdateVendorPayoffErrorAction,
  setUpdateVendorPayoffFetchStatusAction,
} from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { eTitleSearchStatus } from 'types/order/title/eTitleSearchStatus';
import {
  getPayoffOrderAsync,
  sendPayoffToSpruceAsync,
  updatePayoffETAAsync,
} from '../../../API/vendorDashboard/VendorAPI';
import {
  createDefaultVendorPayoffInformationData,
  IVendorPayoffInformationData,
} from '../../../types/vendorDashboard/IVendorPayoffInformation';
import { getTitleReport } from '../../order/titleInformation/dispatch';

export const getVendorPayoffData =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setVendorPayoffErrorAction(undefined));
      dispatch(setVendorPayoffFetchStatusAction(createFetchInProgress()));
      const response = await getPayoffOrderAsync(orderId);
      if (response?.titleCommitmentId) {
        dispatch(getTitleReport(orderId));
      }
      dispatch(setVendorPayoffDataAction({ orderId, value: response }));
      dispatch(setVendorPayoffFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(
        setVendorPayoffDataAction({ orderId, value: { ...createDefaultVendorPayoffInformationData(), orderId } })
      );
      dispatch(setVendorPayoffFetchStatusAction(createFetchedWithError()));
      dispatch(setVendorPayoffErrorAction(e.message));
    }
  };

export const updateEtaPayoff =
  (orderId: string, payoffRequestId: string, eta?: string | null): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setUpdateVendorPayoffErrorAction(undefined));
      dispatch(setUpdateVendorPayoffFetchStatusAction(createFetchInProgress()));
      const response: IVendorPayoffInformationData = await updatePayoffETAAsync(payoffRequestId, eta);
      dispatch(setVendorPayoffDataAction({ orderId, value: response }));
      dispatch(setUpdateVendorPayoffFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setUpdateVendorPayoffFetchStatusAction(createFetchedWithError()));
      dispatch(setUpdateVendorPayoffErrorAction(e.message));
    }
  };

export const sendPayoffToSpruce =
  (orderId: string, payoffRequestId: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setSendToSpruceErrorAction(undefined));
      dispatch(setSendToSpruceFetchStatusAction(createFetchInProgress()));
      await sendPayoffToSpruceAsync(payoffRequestId);
      const orderInfo = getState().vendorDashboard.payoff.payoff[orderId];
      dispatch(setVendorPayoffDataAction({ orderId, value: { ...orderInfo, status: eTitleSearchStatus.sent } }));
      dispatch(setSendToSpruceFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setSendToSpruceFetchStatusAction(createFetchedWithError()));
      dispatch(setSendToSpruceErrorAction(e.message));
      throw Error(e);
    }
  };
